import { nullableUuidString } from '../zod-helpers/nullable-uuid-string.js';
import { requiredClearableField } from './required-clearable-field.js';
export const leafLinkWebhookSettingField = (fieldName, invalidMessage) => requiredClearableField(fieldName, nullableUuidString(invalidMessage));
//# sourceMappingURL=leaflink-webhook-setting-field.js.map